import React, { useEffect, useState } from 'react';
import { MOBILE_BAR, PRICE } from '../constants/content';
import { CtaButton } from './CtaButton';
const SHOW_AFTER_PX = 700;

/**
 * Fixed buy bar for phones. Slides in past 700px of scroll and is hidden
 * from 900px up, where the page already shows inline CTAs.
 */
export function MobileBuyBar() {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const onScroll = () => setShown(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!shown) return null;
  return <div className="buy-bar-in fixed inset-x-0 bottom-0 z-50 border-t-2 border-mustard bg-bordo-deep px-3 py-2.5 shadow-[0_-6px_24px_rgba(0,0,0,0.35)] b900:hidden" data-id="element-167" data-mp="18vrv8t77yvw9">
      <div className="mx-auto flex max-w-2xl items-center gap-3" data-id="element-168" data-mp="z0zwvn5tc50f">
        <div className="shrink-0 leading-none" data-id="element-169" data-mp="13yi5fcfx4i7w">
          <span className="block text-[10px] font-600 uppercase tracking-wide text-cream/70" data-id="element-170" data-mp="13y8dvkf86303">
            {PRICE.full}
          </span>
          <span className="font-display text-xl font-700 text-mustard" data-id="element-171" data-mp="3sj43idoz0zzv">
            {PRICE.today}
          </span>
        </div>
        <CtaButton size="md" className="flex-1" data-id="element-172" data-mp="adr5oxmks2q2">
          {MOBILE_BAR.cta}
        </CtaButton>
      </div>
    </div>;
}